import React, { Fragment } from 'react';

import RadioIcon from '../../icons/RadioIcon';

function QuestionRadio({ answer, parts, onChange, autoFocus = true, questionId = '' }) {
  return (
    <Fragment>
      {parts.map(({ id, label }, i) => (
        <label key={id} className="form__radio-label">
          <RadioIcon checked={answer.parts ? answer.parts[id] : false} />
          <input
            type="radio"
            value={id}
            name={questionId}
            checked={answer.parts ? answer.parts[id] : false}
            onChange={() => onChange(parts.reduce((parts, item) => {
              parts[item.id] = (item.id === id);
              return parts;
            }, {}))}
            autoFocus={autoFocus && i === 0}
          />
          {label}
          <br />
        </label>
      ))}
    </Fragment>
  );
}

export default QuestionRadio;



// WEBPACK FOOTER //
// ./src/components/features/assessment/QuestionRadio.js